// removed by extract-text-webpack-plugin
module.exports = {"Tile":"_1apu6Sou8bTaIe-ehpxUeR","inner":"_3srUT7-vtDNRpoM1DCWXOf","value-2":"_1P4PWA5-R9o8xWvLKMwNCX","value-4":"_1p6IwLEQHn7R0iBF7gy1ZN","value-8":"mS-iTF6B8ZkMNp4pRZw_q","value-16":"Ciq4EH4eS2f1OJdSRzqGK","value-32":"_2pXqm3LELbr1TVAk9pWW_o","value-64":"_12L2BAVOj-PsXqYQTefsc3","value-128":"_2gd-6mnLQVOv8zGQD7VNcK","value-256":"_1CTu7s3xz6kf4KMiCt__KW","value-512":"_3UUxwUTxHe-4y2D_biQ4SN","value-1024":"SCEMnugM3AgMGfbAmWncO","value-2048":"qtpauSjTBUQWPcryDHf1g","value-super":"_1Nj5sO0QIdEwgVUGhEhSjj"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Tile/Tile.scss
 ** module id = 392
 ** module chunks = 1
 **/